
































































import ConnectWalletNetworkBadge from '@/components/walletConnection/ConnectWalletNetworkBadge.vue'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import {Component, Prop} from 'vue-property-decorator'
import {NetworkNamespace} from '@/enums/NetworkNamespace'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {siteNetwork} from '@/helpers/NetworkModeRegistry'

@Component({
  components: {ConnectWalletNetworkBadge},
  computed: {
    NetworkNamespace() {
      return NetworkNamespace
    },
  },
})
export default class ConnectWalletNeon extends MixinScreenSize {
  @Prop({type: String, required: true})
  networkNamespace!: NetworkNamespace
  @Prop({type: String, default: undefined}) targetNetwork?: TWalletNetwork

  get base64URI(): string | null {
    const walletImplementation =
      this.networkNamespace === NetworkNamespace.x ? 'neoX' : 'n3'
    const network = this.targetNetwork ?? siteNetwork()
    const uri: string | null =
      this.$store.state.walletAdapter.sessions[walletImplementation][network]
        ?.uri ?? null

    return uri ? this.encodeUri(uri) : null
  }

  get walletDisplayName() {
    const key = this.isMobile
      ? 'components.ConnectWalletNeon.walletMobileName'
      : 'components.ConnectWalletNeon.walletDesktopName'

    return this.$translate(key)
  }

  returnToChooseWallet() {
    this.$emit('return-page')
  }

  encodeUri(uri: string) {
    return Buffer.from(uri).toString('base64')
  }
}
